module.exports = __webpack_public_path__ + "img/setsuna.14a0249c.png";